<template>
    <div class="grid">
        <div class="col-12 lg:col-5">
            <HorseHistoryChangesDataTable :changes-list="changesHistory" @showRevision="showChangesHistory"/>
        </div>

        <div v-if="selectedVersion" class="selectedVersion col-12 lg:col-7 p-4">
            <RevisionInfo :username="selectedModification.username"
                          :timestamp="selectedModification.timestamp"/>
            <div class="separator mb-3 mt-3"/>
            <DataTable ref="horseHistoryChangesTable" :value="selectedVersion" dataKey="id" size="small">
                <Column field="typeLabel" :header="$t('message.horseEdit.covering.type')" class="w-1">
                    <template #body="{ data }">
                        {{ data.typeLabel }}
                    </template>
                </Column>
                <Column field="season" :header="$t('message.horseEdit.covering.season')" class="w-1">
                    <template #body="{ data }">
                        {{ data.year }}
                    </template>
                </Column>
                <Column field="location" :header="$t('message.horseEdit.covering.location')" class="w-2">
                    <template #body="{ data }">
                        {{ data.location }}
                    </template>
                </Column>
                <Column field="location" :header="$t('message.horseEdit.covering.certificateNumber')" class="w-4">
                    <template #body="{ data }">
                        {{ data.agreementNumberMin }} - {{data.agreementNumberMax}}
                    </template>
                </Column>

                <Column field="location" :header="$t('message.horseEdit.covering.notes')" class="w-8">
                    <template #body="{ data }">
                        {{ data.notes }}
                    </template>
                </Column>

                <template #empty>
                    {{ $t('message.other.emptyTable') }}
                </template>
            </DataTable>
        </div>

    </div>
</template>

<script>
import {
    getCoveringAgreementsAuditTrail,
    getCoveringAgreementsForRevision
} from "@/swagger/vue-api-client";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import HorseHistoryChangesDataTable
    from "@/views/horse/horseEdit/history/compontents/HorseHistoryChangesDataTable.vue";
import RevisionInfo from "@/views/horse/horseEdit/history/compontents/RevisionInfo.vue";

export default {
    name: "HorseCoveringAgreementsHistoryTab",

    components: {
        RevisionInfo,
        HorseHistoryChangesDataTable,
        TabPanel,
        TabView,
        DataTable,
        Column
    },

    props: {
        horse: null,
    },

    data() {
        return {
            changesHistory: null,
            selectedVersion: null,
            selectedModification: {
                timestamp: null,
                username: null
            }
        };
    },

    beforeMount() {
        getCoveringAgreementsAuditTrail({id: this.horse.id}).then((response => {
            this.changesHistory = response.data;
            const lastHistoryEntry = this.changesHistory.length > 0 ? this.changesHistory[0] : undefined;
            const lastRevision = lastHistoryEntry ? lastHistoryEntry.revision : null;
            if (lastRevision != null) {
                this.selectedModification.timestamp = lastHistoryEntry.timestamp;
                this.selectedModification.username = lastHistoryEntry.username;
                getCoveringAgreementsForRevision({id: this.horse.id, revision: lastRevision}).then((response) => {
                    this.selectedVersion = response.data;
                });
            }
        }));

    },

    methods: {
        showChangesHistory(event) {
            if (event?.data?.revision) {
                getCoveringAgreementsForRevision({id: this.horse.id, revision: event.data.revision}).then((response) => {
                    this.selectedVersion = response.data;
                    this.selectedModification.timestamp = event?.data?.timestamp;
                    this.selectedModification.username = event?.data?.username;
                });
            }
        }
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
    .selectedVersion {
        background: var(--dates-background-color);
        color: var(--dates-text-color);
        border-radius: 7px;
    }
</style>
